import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch'
import Tooltip from 'react-tooltip'
import moment from 'moment'

import { holeHelper, uiHelper } from '../../helpers'
import Dima from '../../assets/dima1.png'

import {
  saveHoleDetails,
  lockUnlock,
  certifyPhoto,
  riparablePhoto,
  mustBeRepaired,
  repairedPhoto
} from '../../actions'
import { envConstants, uiConstants } from '../../constants'

import EventsChart from './EventsChart'
import HoleHistory from './HoleHistory'
import EventsList from './EventsList'
import StreetView from './StreetView'
import PhotoUploader from '../Inspections/PhotoUploader'

const initialState = {
  showEdit: false,
  notes: null,
  estimated_intervention: null,
  intervention_summary: null,
  anomalyType: null,
  manage: true,
  details: true,
  more: true,
  events: false,
  media: true,
  chart: true,
  street: true,
  history: false,
  imageIndex: 0,
  onlyUtilsPhoto: false,
  imageResolution: uiConstants.imageQuality.medium,
  showDima: false
}

class Hole extends Component {
  constructor() {
    super()
    this.state = initialState
    this.escFunction = this.escFunction.bind(this)
    this.uploadClick = this.uploadClick.bind(this)
  }

  escFunction(event) {
    switch (event.keyCode) {
      case 27:
        if (this.state.showEdit) {
          this.editAnomaly(true)
        }
        break
      default:
        break
    }
  }

  nextHole(dir) {
    this.setState({ imageIndex: 0 }, () => {
      this.props.changeHole(dir)
    })
  }

  endsHole(dir) {
    this.setState({ imageIndex: 0 }, () => {
      this.props.endsHole(dir)
    })
  }

  editAnomaly(force = false) {
    const s = this.state
    if (s.showEdit || force) {
      this.setState({ showEdit: false, notes: this.props.dashboard.hole.notes })
    } else {
      this.setState({ showEdit: true })
    }
  }

  saveAnomalyInfo() {
    this.props.saveHoleDetails(this.props.dashboard.hole.id, {
      notes: this.state.notes,
      anomalyType: this.state.anomalyType,
      estimated_intervention: this.state.estimated_intervention,
      intervention_summary: this.state.intervention_summary
    })
    // this.editAnomaly()
  }

  lockAnomaly() {
    this.props.lockUnlock(this.props.dashboard.hole.id)
  }

  unlockAnomaly() {
    this.props.lockUnlock(this.props.dashboard.hole.id)
  }

  toggleSection(name) {
    this.setState({ [name]: !this.state[name] })
  }

  showImage() {
    const s = this.state
    const medias = this.props.dashboard.hole.medias
    return medias.filter((x) =>
      s.onlyUtilsPhoto
        ? x.certified === 1 || x.riparable === 1 || x.repaired === 1
        : true
    )[s.imageIndex]
  }

  changeImageResolution() {
    this.setState({
      imageResolution:
        this.state.imageResolution === uiConstants.imageQuality.medium
          ? uiConstants.imageQuality.high
          : uiConstants.imageQuality.medium
    })
  }

  changeImageIndex(imageIndex) {
    this.setState({ imageIndex })
  }

  navImage(dir) {
    const s = this.state
    const images = this.props.dashboard.hole.medias.filter((x) =>
      s.onlyUtilsPhoto
        ? x.certified === 1 || x.riparable === 1 || x.repaired === 1
        : true
    )
    let nid = s.imageIndex + dir
    if (nid < 0) {
      nid = images.length - 1
    }
    if (nid >= images.length) {
      nid = 0
    }
    this.changeImageIndex(nid)
  }

  uploadClick(action) {
    if (action === 'generic') {
      this.genericChild.fileUploadAction()
    } else {
      this.repairedChild.fileUploadAction()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const p = prevProps.dashboard
    const c = this.props.dashboard
    if (p.loading && !c.loading) {
      const h = c.hole
      this.setState({
        notes: h.notes,
        anomalyType: h.anomalyType,
        estimated_intervention: h.estimated_intervention,
        intervention_summary: h.intervention_summary,
        showEdit: false
      })
    }
  }

  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false)
  }

  render() {
    const { hole, list } = this.props.dashboard
    const index = this.props.index + 1
    const s = this.state
    return (
      hole !== null && (
        <>
          <div className='hole-details'>
            <div className='hole-nav-c'>
              <ul className='hole-nav'>
                <li>
                  <button
                    className={
                      'lnk-cert-hole' +
                      (hole.mustberepaired === 0 ? '' : ' yes')
                    }
                    onClick={() => {
                      this.props.mustBeRepaired(hole.id, hole)
                    }}
                  >
                    <i
                      className={
                        'fas ' +
                        (hole.mustberepaired === 0 ? 'fa-minus' : 'fa-check')
                      }
                    ></i>
                  </button>
                </li>
              </ul>
              <ul className='hole-nav'>
                {this.props.index > -1 && (
                  <Fragment>
                    <li>
                      {index}/{list.length}
                    </li>
                    <li>
                      <button
                        className='lnk-nav-hole'
                        onClick={() => this.endsHole(-1)}
                      >
                        <i className='fas fa-angle-double-left'></i>
                      </button>
                    </li>
                    <li>
                      <button
                        className='lnk-nav-hole'
                        onClick={() => this.nextHole(-1)}
                      >
                        <i className='fas fa-chevron-left'></i>
                      </button>
                    </li>
                    <li>
                      <button
                        className='lnk-nav-hole'
                        onClick={() => this.nextHole(1)}
                      >
                        <i className='fas fa-chevron-right'></i>
                      </button>
                    </li>
                    <li>
                      <button
                        className='lnk-nav-hole'
                        onClick={() => this.endsHole(1)}
                      >
                        <i className='fas fa-angle-double-right'></i>
                      </button>
                    </li>
                  </Fragment>
                )}
                <li>
                  <button
                    onClick={() => this.props.hideDetails()}
                    className='lnk-nav-hole'
                  >
                    <i className='fas fa-times'></i>
                  </button>
                </li>
              </ul>
            </div>

            <div className='hole-s-c'>
              <ul className='sections'>
                {uiHelper.canUse(uiConstants.grant.manageHole) && (
                  <li>
                    <button
                      className='lnk-hole-section red'
                      onClick={() => this.toggleSection('manage')}
                    >
                      <i className='fas fa-tools'></i>
                    </button>
                    <div className='info'>
                      <div className='info-title'>Gestisci anomalia</div>
                      <div
                        className={'info-body ' + (s.manage ? '' : 'hidden')}
                      >
                        {hole.owner === null && (
                          <div>
                            <button
                              className='lnk-manage blue'
                              onClick={() => this.lockAnomaly()}
                            >
                              <i className='fas fa-lock'></i>
                            </button>
                            Questa anomalia è visible a tutti, clicca sull'icona
                            qui di fianco per prenderla in carico
                          </div>
                        )}
                        {hole.owner !== null && (
                          <div>
                            <button
                              className='lnk-manage blue'
                              onClick={() => this.unlockAnomaly()}
                            >
                              <i className='fas fa-lock-open'></i>
                            </button>
                            Rilascia anomalia
                          </div>
                        )}
                      </div>
                    </div>
                  </li>
                )}
                <li>
                  <button
                    className='lnk-hole-section indigo'
                    onClick={() => this.toggleSection('details')}
                  >
                    <i className='fas fa-map-signs'></i>
                  </button>
                  <div className='info'>
                    <div className='info-title'>Dettagli anomalia</div>
                    <div className={'info-body ' + (s.details ? '' : 'hidden')}>
                      <a
                        href={
                          'https://www.google.com/maps/dir/?api=1&destination=' +
                          hole.latitude +
                          ',' +
                          hole.longitude
                        }
                        rel='noopener noreferrer'
                        className='lnk-manage blue'
                        target='_blank'
                      >
                        <i className='fas fa-location-arrow'></i>
                      </a>
                      <ul className='h-details'>
                        <li>
                          <span className='title'>ID</span>
                          {hole.id}
                        </li>
                        <li>
                          <span className='title'>Nazione</span>
                          {hole.country}
                        </li>
                        <li>
                          <span className='title'>Regione</span>
                          {hole.region}
                        </li>
                        <li>
                          <span className='title'>Provincia</span>
                          {hole.district_long}
                        </li>
                        <li>
                          <span className='title'>Comune</span>
                          {hole.city}
                        </li>
                        <li>
                          <span className='title'>Indirizzo</span>
                          {hole.address}
                        </li>
                        <li>
                          <span className='title'>Indirizzo completo</span>
                          {hole.formattedAddress}
                        </li>
                        <li>
                          <span className='title'>Coordinate GPS</span>
                          {hole.latitude}, {hole.longitude}
                        </li>
                        <li>
                          <span className='title'>Direzione</span>
                          {hole.direction} ({hole.bearing}°)
                        </li>
                        <li>
                          <span className='title'>Grado</span>
                          <img
                            src={holeHelper.holeMarker(hole, false)}
                            alt={hole.severity}
                          />
                        </li>
                        <li>
                          <span className='title'>Dati normalizzati</span>
                          {hole.normalized === 0 && (
                            <i className='fas fa-exclamation-circle'></i>
                          )}
                          {hole.normalized === 1 && (
                            <i className='fas fa-check-circle'></i>
                          )}
                        </li>
                        <li
                          className={
                            'status ' + holeHelper.colorStatus(hole.status)
                          }
                        >
                          <span className='title'>Stato</span>
                          <img
                            src={holeHelper.holeStatusMarker(hole)}
                            alt={hole.status}
                          />
                        </li>
                        <li>
                          <span className='title'>Numero rilevazioni</span>
                          {hole.events?.length}
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li>
                  <button
                    className='lnk-hole-section orange'
                    onClick={() => this.toggleSection('more')}
                  >
                    <i className='fas fa-info'></i>
                  </button>
                  <div className='info'>
                    <div className='info-title'>Dettagli aggiuntivi</div>
                    <div className={'info-body ' + (s.more ? '' : 'hidden')}>
                      <button
                        className='lnk-manage blue'
                        onClick={() => this.editAnomaly()}
                      >
                        {this.state.showEdit && (
                          <i className='fas fa-times'></i>
                        )}
                        {!this.state.showEdit && (
                          <i className='fas fa-pencil-alt'></i>
                        )}
                      </button>
                      {this.state.showEdit && (
                        <button
                          className='lnk-manage second blue'
                          onClick={() => this.saveAnomalyInfo()}
                        >
                          <i className='far fa-save'></i>
                        </button>
                      )}
                      <ul className='h-details'>
                        <li>
                          <span className='title'>Tipo di anomalia</span>
                          {!this.state.showEdit && hole.anomalyType}
                          {this.state.showEdit && (
                            <select
                              onChange={(event) =>
                                this.setState({
                                  anomalyType: event.target.value
                                })
                              }
                              value={this.state.anomalyType}
                            >
                              <option value=''>-</option>
                              {envConstants.anomalyTypes.map((t, index) => {
                                return (
                                  <option value={t} key={index}>
                                    {t}
                                  </option>
                                )
                              })}
                            </select>
                          )}
                        </li>
                        <li>
                          <span className='title'>Note</span>
                          {!this.state.showEdit && hole.notes}
                          {this.state.showEdit && (
                            <textarea
                              name='note'
                              onChange={(event) =>
                                this.setState({ notes: event.target.value })
                              }
                              value={this.state.notes}
                            ></textarea>
                          )}
                        </li>
                        <li>
                          <span className='title'>Intervento stimato</span>
                          {!this.state.showEdit && hole.estimated_intervention}
                          {this.state.showEdit && (
                            <input
                              type='number'
                              onChange={(event) =>
                                this.setState({
                                  estimated_intervention: event.target.value
                                })
                              }
                              value={this.state.estimated_intervention}
                            />
                          )}
                        </li>
                        <li>
                          <span className='title'>Consuntivo intervento</span>
                          {!this.state.showEdit && hole.intervention_summary}
                          {this.state.showEdit && (
                            <textarea
                              name='intervention_summary'
                              onChange={(event) =>
                                this.setState({
                                  intervention_summary: event.target.value
                                })
                              }
                              value={this.state.intervention_summary}
                            ></textarea>
                          )}
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li>
                  <button
                    className='lnk-hole-section purple'
                    onClick={() => this.toggleSection('events')}
                  >
                    <i className='far fa-calendar-alt'></i>
                  </button>
                  <div className='info'>
                    <div className='info-title'>
                      Dettagli rilevazioni{' '}
                      {!s.events ? '(' + hole.events.length + ')' : ''}
                    </div>
                    <div className={'info-body ' + (s.events ? '' : 'hidden')}>
                      <EventsList events={hole.events} />
                    </div>
                  </div>
                </li>
                <li>
                  <button
                    className='lnk-hole-section cyan'
                    onClick={() => this.toggleSection('chart')}
                  >
                    <i className='far fa-chart-bar'></i>
                  </button>
                  <div className='info'>
                    <div className='info-title'>Grafico</div>
                    <div className={'info-body ' + (s.chart ? '' : 'hidden')}>
                      <EventsChart events={hole.events} />
                    </div>
                  </div>
                </li>
                <li>
                  <button
                    className='lnk-hole-section amber'
                    onClick={() => this.toggleSection('street')}
                  >
                    <i className='fas fa-street-view'></i>
                  </button>
                  <div className='info'>
                    <div className='info-title'>Street View</div>
                    <div className={'info-body ' + (s.street ? '' : 'hidden')}>
                      {s.street && <StreetView hole={hole} />}
                    </div>
                  </div>
                </li>
                <li>
                  <button
                    className='lnk-hole-section green'
                    onClick={() => this.toggleSection('media')}
                  >
                    <i className='fas fa-photo-video'></i>
                  </button>
                  <div className='info'>
                    <div className='info-title'>
                      Media {!s.media ? '(' + hole.medias.length + ')' : ''}
                    </div>
                    <div className={'info-body ' + (s.media ? '' : 'hidden')}>
                      <Tooltip
                        id='genericPhoto'
                        effect='solid'
                        className='nav-tip-upper'
                      >
                        Carica foto
                      </Tooltip>
                      <button
                        className='lnk-manage blue'
                        onClick={() => this.uploadClick('generic')}
                        data-tip=''
                        data-for='genericPhoto'
                      >
                        <i className='fas fa-plus'></i>
                      </button>

                      {(hole.medias || []).filter(
                        (x) =>
                          x.certified === 1 ||
                          x.riparable === 1 ||
                          x.repaired === 1
                      ).length > 0 && (
                        <div className='show-only-utils-photo'>
                          <label>
                            <input
                              type='checkbox'
                              checked={s.onlyUtilsPhoto}
                              onChange={(e) =>
                                this.setState({
                                  onlyUtilsPhoto: e.target.checked,
                                  imageIndex: 0
                                })
                              }
                            />{' '}
                            visualizza solo foto utili
                          </label>
                        </div>
                      )}

                      {hole.mustberepaired === 1 && (
                        <>
                          <Tooltip
                            id='repairedPhoto'
                            effect='solid'
                            className='nav-tip-upper'
                          >
                            Carica foto riparazione
                          </Tooltip>
                          <button
                            className='lnk-manage second blue'
                            onClick={() => this.uploadClick('repaired')}
                            data-tip=''
                            data-for='repairedPhoto'
                          >
                            <i className='fas fa-briefcase-medical'></i>
                          </button>
                        </>
                      )}
                      {(hole.medias || []).length > 0 && (
                        <>
                          <Tooltip
                            id='zoomIn'
                            effect='solid'
                            className='nav-tip-upper'
                          >
                            Zoom in
                          </Tooltip>
                          <Tooltip
                            id='zoomOut'
                            effect='solid'
                            className='nav-tip-upper'
                          >
                            Zoom out
                          </Tooltip>
                          <Tooltip
                            id='originalSize'
                            effect='solid'
                            className='nav-tip-upper'
                          >
                            reset zoom
                          </Tooltip>
                          <Tooltip
                            id='changeResolution'
                            effect='solid'
                            className='nav-tip-upper'
                          >
                            Cambia risoluzione
                          </Tooltip>
                          <Tooltip
                            id='close'
                            effect='solid'
                            className='nav-tip-upper'
                          >
                            Chiudi
                          </Tooltip>
                          <Tooltip
                            id='prev-image'
                            effect='solid'
                            className='nav-tip-upper'
                          >
                            Immagine successiva
                          </Tooltip>
                          <Tooltip
                            id='next-iamge'
                            effect='solid'
                            className='nav-tip-upper'
                          >
                            Immagine precedente
                          </Tooltip>
                          <Tooltip
                            id='certified'
                            effect='solid'
                            className='nav-tip-upper'
                          >
                            Valida
                          </Tooltip>
                          <Tooltip
                            id='riparable'
                            effect='solid'
                            className='nav-tip-upper'
                          >
                            Riparabile
                          </Tooltip>
                          <Tooltip
                            id='repaired'
                            effect='solid'
                            className='nav-tip-upper'
                          >
                            Riparazione
                          </Tooltip>
                          <Tooltip
                            id='dima'
                            effect='solid'
                            className='nav-tip-upper'
                          >
                            Dima
                          </Tooltip>
                          <Tooltip
                            id='download'
                            effect='solid'
                            className='nav-tip-upper'
                          >
                            Download
                          </Tooltip>
                          <TransformWrapper
                            defaultScale={1}
                            defaultPositionX={100}
                            defaultPositionY={100}
                          >
                            {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                              <React.Fragment>
                                {/* onLoad={() => { console.log('d'); resetTransform()}} */}
                                <div className='hole-image-container'>
                                  <ul className='image-ld'>
                                    <li>
                                      <i className='fas fa-location-arrow'></i>
                                      {this.showImage().latitude},{' '}
                                      {this.showImage().longitude}
                                    </li>
                                    <li>
                                      <i className='far fa-clock'></i>
                                      {moment
                                        .unix(this.showImage().mediadate)
                                        .format(envConstants.momentFormat)}
                                    </li>
                                  </ul>
                                  <ul className='image-tools'>
                                    <li>
                                      <button
                                        className='btn-image-tools'
                                        data-tip=''
                                        data-for='zoomOut'
                                        onClick={zoomOut}
                                      >
                                        <i className='fas fa-search-minus'></i>
                                      </button>
                                    </li>
                                    <li>
                                      <button
                                        className='btn-image-tools'
                                        data-tip=''
                                        data-for='zoomIn'
                                        onClick={zoomIn}
                                      >
                                        <i className='fas fa-search-plus'></i>
                                      </button>
                                    </li>
                                    <li>
                                      <button
                                        className='btn-image-tools'
                                        data-tip=''
                                        data-for='originalSize'
                                        onClick={resetTransform}
                                      >
                                        <i className='fas fa-expand'></i>
                                      </button>
                                    </li>
                                    <li>
                                      <button
                                        className='btn-image-tools'
                                        data-tip=''
                                        data-for='changeResolution'
                                        onClick={() =>
                                          this.changeImageResolution()
                                        }
                                      >
                                        <i className='fas fa-random'></i>
                                      </button>
                                    </li>
                                    <li>
                                      <button
                                        className='btn-image-tools'
                                        data-tip=''
                                        data-for='prev-image'
                                        onClick={() => this.navImage(-1)}
                                      >
                                        <i className='fas fa-chevron-left'></i>
                                      </button>
                                    </li>
                                    <li>
                                      <button
                                        className='btn-image-tools'
                                        data-tip=''
                                        data-for='next-image'
                                        onClick={() => this.navImage(1)}
                                      >
                                        <i className='fas fa-chevron-right'></i>
                                      </button>
                                    </li>
                                    <li>
                                      <button
                                        data-tip=''
                                        data-for='repaired'
                                        className={
                                          'btn-image-tools ' +
                                          (this.showImage().repaired === 0
                                            ? ''
                                            : 'certified')
                                        }
                                        onClick={() =>
                                          this.props.repairedPhoto({
                                            id: this.showImage().id
                                          })
                                        }
                                      >
                                        <i className='fas fa-briefcase-medical'></i>
                                      </button>
                                    </li>
                                    <li>
                                      <button
                                        data-tip=''
                                        data-for='riparable'
                                        className={
                                          'btn-image-tools ' +
                                          (this.showImage().riparable === 0
                                            ? ''
                                            : 'certified')
                                        }
                                        onClick={() =>
                                          this.props.riparablePhoto({
                                            id: this.showImage().id
                                          })
                                        }
                                      >
                                        <i className='fas fa-hammer'></i>
                                      </button>
                                    </li>
                                    <li>
                                      <button
                                        data-tip=''
                                        data-for='certified'
                                        className={
                                          'btn-image-tools ' +
                                          (this.showImage().certified === 0
                                            ? ''
                                            : 'certified')
                                        }
                                        onClick={() =>
                                          this.props.certifyPhoto({
                                            id: this.showImage().id
                                          })
                                        }
                                      >
                                        <i className='far fa-star'></i>
                                      </button>
                                    </li>
                                    <li>
                                      <button
                                        className={
                                          'btn-image-tools ' +
                                          (s.showDima ? 'certified' : '')
                                        }
                                        data-tip=''
                                        data-for='dima'
                                        onClick={() =>
                                          this.setState({
                                            showDima: !s.showDima
                                          })
                                        }
                                      >
                                        <i className='fas fa-ruler-combined'></i>
                                      </button>
                                    </li>
                                    <li>
                                      <a
                                        href={holeHelper.imageMarker(
                                          this.showImage().guid,
                                          s.imageResolution
                                        )}
                                        className={'btn-image-tools '}
                                        target='_blank'
                                        rel='noopener noreferrer'
                                        aria-label='Download'
                                        data-tip=''
                                        data-for='download'
                                      >
                                        <i className='fas fa-download'></i>
                                      </a>
                                    </li>
                                  </ul>
                                  <TransformComponent>
                                    <div className='image-viewer-container'>
                                      <img
                                        src={holeHelper.imageMarker(
                                          this.showImage().guid,
                                          s.imageResolution
                                        )}
                                        alt={
                                          'drone photo ' + this.showImage().guid
                                        }
                                      />
                                      {s.showDima && (
                                        <img
                                          src={Dima}
                                          alt='dima'
                                          className='dima'
                                        />
                                      )}
                                    </div>
                                  </TransformComponent>
                                </div>
                              </React.Fragment>
                            )}
                          </TransformWrapper>
                          <ul className='ul-medias'>
                            {(hole.medias || [])
                              .filter((x) =>
                                s.onlyUtilsPhoto
                                  ? x.certified === 1 ||
                                    x.riparable === 1 ||
                                    x.repaired === 1
                                  : true
                              )
                              .map((m, index) => {
                                let cls = ''
                                if (m.repaired === 1) {
                                  cls = 'repa'
                                } else if (m.riparable === 1) {
                                  cls = 'ripa'
                                } else if (m.certified === 1) {
                                  cls = 'cert'
                                }
                                return (
                                  <li
                                    key={index}
                                    className={
                                      cls +
                                      (index === s.imageIndex
                                        ? ' cur-image'
                                        : '')
                                    }
                                    onClick={() => this.changeImageIndex(index)}
                                  >
                                    <img
                                      src={holeHelper.imageMarker(m.guid, 1)}
                                      alt={m.id}
                                    />
                                  </li>
                                )
                              })}
                          </ul>
                        </>
                      )}
                    </div>
                  </div>
                </li>
                {uiHelper.canUse(uiConstants.grant.manageHole) && (
                  <li>
                    <button
                      className='lnk-hole-section lime'
                      onClick={() => this.toggleSection('history')}
                    >
                      <i className='fas fa-history'></i>
                    </button>
                    <div className='info'>
                      <div className='info-title'>
                        Eventi{' '}
                        {!s.history ? '(' + hole.history.length + ')' : ''}
                      </div>
                      <div
                        className={'info-body ' + (s.history ? '' : 'hidden')}
                      >
                        <HoleHistory history={hole.history} />
                      </div>
                    </div>
                  </li>
                )}
              </ul>
            </div>
          </div>
          <PhotoUploader
            footprint={{
              holeid: hole.id,
              field_label: 'certified',
              field_value: '0'
            }}
            onRef={(ref) => (this.genericChild = ref)}
          />
          <PhotoUploader
            footprint={{
              holeid: hole.id,
              field_label: 'repaired',
              field_value: '1'
            }}
            onRef={(ref) => (this.repairedChild = ref)}
          />
        </>
      )
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, {
  saveHoleDetails,
  lockUnlock,
  certifyPhoto,
  riparablePhoto,
  mustBeRepaired,
  repairedPhoto
})(Hole)
